import React from 'react';

import { SelectProps } from 'antd/es/select';

import ItemsSelect from '@common/react/components/Core/ItemsSelect/ItemsSelect';
import FormikField, { FormikFieldProps } from '@common/react/components/Forms/FormikField/FormikField';

interface TimeZoneInfo {
	id: string;
	displayName: string;
	baseUtcOffset?: string;
}

interface Props extends Omit<FormikFieldProps, 'fieldName' | 'render' | 'children'> {
	timeZoneListDefault?: Array<TimeZoneInfo>;
	selectProps?: Omit<SelectProps, 'onChange'>;
}

interface SelectItem extends Omit<TimeZoneInfo, 'id'> {
	key: string;
	id: number;
}

const FormikFieldTimeZoneSelect: React.FC<Props> = ({
	timeZoneListDefault,
	selectProps,
	...rest
}) => {
	return (
		<FormikField
			fieldName="timeZoneId"
			title="Time Zone*"
			containerClassName="form-group col-sm-12"
			{...rest}
		>
			{({ field, form }) => (
				<ItemsSelect<SelectItem>
					items={timeZoneListDefault as any}
					pagination={{
						pageSize: 200,
					}}
					loadRequest="timeZoneList"
					selectProps={{
						onChange: (value) => form.setFieldValue(field.name, value),
						defaultValue: field.value,
						...selectProps,
						placeholder: 'Time Zone*',
					}}
					getOptionProps={(item) => ({
						value: item.id,
						children: <>{item.displayName}</>,
						item,
					})}
				/>
			)}
		</FormikField>
	);
};

export default FormikFieldTimeZoneSelect;
